import Reporting from './Reporting';
import { mapDispatchToProps, mapStateToProps } from './Reporting.state';
import { connect } from 'react-redux';

export default connect(mapStateToProps, mapDispatchToProps)(Reporting);
